import Home from "./home/Home";
import GuestHome from "./guestHome/GuestHome";

import Renter from "./renterUrgente/Renter";
const pages = {
  Home,
  GuestHome,
  Renter,
};
export default pages;
